var N = Object.defineProperty;
var V = (s, t, e) => t in s ? N(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var f = (s, t, e) => V(s, typeof t != "symbol" ? t + "" : t, e);
import b from "react";
import { jsx as E } from "react/jsx-runtime";
class M {
  constructor(t = /* @__PURE__ */ new Map()) {
    this.map = t;
  }
  clone() {
    return new M(new Map(this.map));
  }
  increment(t) {
    const e = this.map.get(t) ?? 0;
    this.map.set(t, e + 1);
  }
  decrement(t, e) {
    let n = this.map.get(t);
    n !== void 0 && (n -= 1, this.map.set(t, n), n === 0 && e());
  }
}
class y {
  constructor() {
    f(this, "map", /* @__PURE__ */ new Map());
  }
  getOrCreate(t) {
    let e = this.map.get(t);
    return e === void 0 && (e = /* @__PURE__ */ new Set(), this.map.set(t, e)), e;
  }
  get(t) {
    return this.map.get(t);
  }
  use(t, e) {
    const n = this.get(t);
    n !== void 0 && e(n);
  }
  delete(t) {
    return this.map.delete(t);
  }
}
function m(s, t) {
  return t(s), s;
}
function S() {
}
function C(s, t) {
  return s === t;
}
const w = /* @__PURE__ */ new Map();
class j {
  /**
   * Creates a new realm.
   * @param initialValues - the initial cell values that will populate the realm.
   * Those values will not trigger a recomputation cycle, and will overwrite the initial values specified for each cell.
   */
  constructor(t = {}) {
    f(this, "subscriptions", new y());
    f(this, "singletonSubscriptions", /* @__PURE__ */ new Map());
    f(this, "graph", new y());
    f(this, "state", /* @__PURE__ */ new Map());
    f(this, "distinctNodes", /* @__PURE__ */ new Map());
    f(this, "executionMaps", /* @__PURE__ */ new Map());
    f(this, "definitionRegistry", /* @__PURE__ */ new Set());
    for (const e of Object.getOwnPropertySymbols(t))
      this.state.set(e, t[e]);
  }
  /**
   * Creates or resolves an existing cell instance in the realm. Useful as a joint point when building your own operators.
   * @returns a reference to the cell.
   * @param value - the initial value of the cell
   * @param distinct - true by default. Pass false to mark the signal as a non-distinct one, meaning that publishing the same value multiple times will re-trigger a recomputation cycle.
   * @param node - optional, a reference to a cell. If the cell has not been touched in the realm before, the realm will instantiate a reference to it. If it's registered already, the function will return the reference.
   */
  cellInstance(t, e = !0, n = Symbol()) {
    return this.state.has(n) || this.state.set(n, t), e !== !1 && !this.distinctNodes.has(n) && this.distinctNodes.set(n, e === !0 ? C : e), n;
  }
  /**
   * Creates or resolves an existing signal instance in the realm. Useful as a joint point when building your own operators.
   * @returns a reference to the signal.
   * @param distinct - true by default. Pass false to mark the signal as a non-distinct one, meaning that publishing the same value multiple times will re-trigger a recomputation cycle.
   * @param node - optional, a reference to a signal. If the signal has not been touched in the realm before, the realm will instantiate a reference to it. If it's registered already, the function will return the reference.
   */
  signalInstance(t = !0, e = Symbol()) {
    return t !== !1 && this.distinctNodes.set(e, t === !0 ? C : t), e;
  }
  /**
   * Subscribes to the values published in the referred node.
   * @param node - the cell/signal to subscribe to.
   * @param subscription - the callback to execute when the node receives a new value.
   * @returns a function that, when called, will cancel the subscription.
   *
   * @example
   * ```ts
   * const signal$ = Signal<number>()
   * const r = new Realm()
   * const unsub = r.sub(signal$, console.log)
   * r.pub(signal$, 2)
   * unsub()
   * r.pub(signal$, 3)
   * ```
   */
  sub(t, e) {
    this.register(t);
    const n = this.subscriptions.getOrCreate(t);
    return n.add(e), () => n.delete(e);
  }
  /**
   * Subscribes exclusively to values in the referred node.
   * Calling this multiple times on a single node will remove the previous subscription created through `singletonSub`.
   * Subscriptions created through `sub` are not affected.
   * @returns a function that, when called, will cancel the subscription.
   *
   * @example
   * ```ts
   * const signal$ = Signal<number>()
   * const r = new Realm()
   * // console.log will run only once.
   * r.singletonSub(signal$, console.log)
   * r.singletonSub(signal$, console.log)
   * r.singletonSub(signal$, console.log)
   * r.pub(signal$, 2)
   * ```
   */
  singletonSub(t, e) {
    return this.register(t), e === void 0 ? this.singletonSubscriptions.delete(t) : this.singletonSubscriptions.set(t, e), () => this.singletonSubscriptions.delete(t);
  }
  /**
   * Clears all exclusive subscriptions.
   */
  resetSingletonSubs() {
    this.singletonSubscriptions.clear();
  }
  subMultiple(t, e) {
    const n = this.signalInstance();
    return this.connect({
      map: (i) => (...r) => {
        i(r);
      },
      sink: n,
      sources: t
    }), this.sub(n, e);
  }
  /**
   * Publishes into multiple nodes simultaneously, triggering a single re-computation cycle.
   * @param values - a record of node references and their values.
   *
   * @example
   * ```ts
   * const foo$ = Cell('foo')
   * const bar$ = Cell('bar')
   *
   * const r = new Realm()
   * r.pubIn({[foo$]: 'foo1', [bar$]: 'bar1'})
   * ```
   */
  pubIn(t) {
    var a;
    const e = Reflect.ownKeys(t), n = this.getExecutionMap(e), i = n.refCount.clone(), r = n.participatingNodes.slice(), o = new Map(this.state), l = (p) => {
      this.graph.use(p, (c) => {
        for (const { sources: u, sink: d } of c)
          u.has(p) && i.decrement(d, () => {
            r.splice(r.indexOf(d), 1), l(d);
          });
      });
    };
    for (; ; ) {
      const p = r.shift();
      if (p === void 0)
        break;
      const c = p;
      let u = !1;
      const d = (h) => {
        const g = this.distinctNodes.get(c);
        if (g !== void 0 && g(o.get(c), h)) {
          u = !1;
          return;
        }
        u = !0, o.set(c, h), this.state.has(c) && this.state.set(c, h);
      };
      if (Object.prototype.hasOwnProperty.call(t, c) ? d(t[c]) : n.projections.use(c, (h) => {
        for (const g of h) {
          const k = [...Array.from(g.sources), ...Array.from(g.pulls)].map((R) => o.get(R));
          g.map(d)(...k);
        }
      }), u) {
        const h = o.get(c);
        this.subscriptions.use(c, (g) => {
          for (const k of g)
            k(h);
        }), (a = this.singletonSubscriptions.get(c)) == null || a(h);
      } else
        l(c);
    }
  }
  /**
   * A low-level utility that connects multiple nodes to a sink node with a map function. Used as a foundation for the higher-level operators.
   * The nodes can be active (sources) or passive (pulls).
   */
  connect({
    sources: t,
    pulls: e = [],
    map: n,
    sink: i
  }) {
    const r = {
      map: n,
      pulls: new Set(e),
      sink: this.register(i),
      sources: new Set(t)
    };
    for (const o of [...t, ...e])
      this.register(o), this.graph.getOrCreate(o).add(r);
    this.executionMaps.clear();
  }
  pub(t, e) {
    this.pubIn({ [t]: e });
  }
  pipe(t, ...e) {
    return this.combineOperators(...e)(t);
  }
  transformer(...t) {
    return (e) => m(this.signalInstance(), (n) => (this.link(this.pipe(n, ...t), e), n));
  }
  /**
   * Links the output of a node to the input of another node.
   */
  link(t, e) {
    this.connect({
      map: (n) => (i) => {
        n(i);
      },
      sink: e,
      sources: [t]
    });
  }
  // prettier-ignore
  combine(...t) {
    return m(this.signalInstance(), (e) => {
      this.connect({
        map: (n) => (...i) => {
          n(i);
        },
        sink: e,
        sources: t
      });
    });
  }
  // prettier-ignore
  combineCells(...t) {
    return m(
      this.cellInstance(
        t.map((e) => this.getValue(e)),
        !0
      ),
      (e) => {
        this.connect({
          map: (n) => (...i) => {
            n(i);
          },
          sink: e,
          sources: t
        });
      }
    );
  }
  /**
   * Gets the current value of a node. The node must be stateful.
   * @remark if possible, use {@link withLatestFrom} or {@link combine}, as getValue will not create a dependency to the passed node,
   * which means that if you call it within a computational cycle, you may not get the correct value.
   * @param node - the node instance.
   * @example
   * ```ts
   * const foo$ = Cell('foo')
   *
   * const r = new Realm()
   * r.getValue(foo$) // 'foo'
   * r.pub(foo$, 'bar')
   * //...
   * r.getValue(foo$) // 'bar'
   * ```
   */
  getValue(t) {
    return this.register(t), this.state.get(t);
  }
  getValues(t) {
    return t.map((e) => this.getValue(e));
  }
  /**
   * Explicitly includes the specified cell/signal reference in the realm.
   * Most of the time you don't need to do that, since any interaction with the node through a realm will register it.
   * The only exception of that rule should be when the interaction is conditional, and the node definition includes an init function that needs to be eagerly evaluated.
   */
  register(t) {
    const e = w.get(t);
    return e === void 0 || this.definitionRegistry.has(t) ? t : (this.definitionRegistry.add(t), m(
      e.type === "cell" ? this.cellInstance(e.initial, e.distinct, t) : this.signalInstance(e.distinct, t),
      (n) => {
        e.init(this, n);
      }
    ));
  }
  /**
   * Convenient for mutation of cells that contian non-primitive values (e.g. arrays, or objects).
   * Specifies that the cell value should be changed when source emits, with the result of the map callback parameter.
   * the map parameter gets called with the current value of the cell and the value published through the source.
   * @typeParam T - the type of the cell value.
   * @typeParam K - the type of the value published through the source.
   * @example
   * ```ts
   * const items$ = Cell<string[]([])
   * const addItem$ = Signal<string>(false, (r) => {
   *   r.changeWith(items$, addItem$, (items, item) => [...items, item])
   * })
   * const r = new Realm()
   * r.pub(addItem$, 'foo')
   * r.pub(addItem$, 'bar')
   * r.getValue(items$) // ['foo', 'bar']
   * ```
   */
  changeWith(t, e, n) {
    this.connect({
      sources: [e],
      pulls: [t],
      sink: t,
      map: (i) => (r, o) => {
        i(n(o, r));
      }
    });
  }
  calculateExecutionMap(t) {
    const e = [], n = /* @__PURE__ */ new Set(), i = new y(), r = new M(), o = new y(), l = (a, p = 0) => {
      r.increment(a), !n.has(a) && (this.register(a), i.use(a, (c) => {
        p = Math.max(...Array.from(c).map((u) => e.indexOf(u))) + 1;
      }), this.graph.use(a, (c) => {
        for (const u of c)
          u.sources.has(a) ? (o.getOrCreate(u.sink).add(u), l(u.sink, p)) : i.getOrCreate(u.sink).add(a);
      }), n.add(a), e.splice(p, 0, a));
    };
    return t.forEach(l), { participatingNodes: e, pendingPulls: i, projections: o, refCount: r };
  }
  getExecutionMap(t) {
    let e = t;
    if (t.length === 1) {
      e = t[0];
      const i = this.executionMaps.get(e);
      if (i !== void 0)
        return i;
    } else
      for (const [i, r] of this.executionMaps.entries())
        if (Array.isArray(i) && i.length === t.length && i.every((o) => t.includes(o)))
          return r;
    const n = this.calculateExecutionMap(t);
    return this.executionMaps.set(e, n), n;
  }
  combineOperators(...t) {
    return (e) => {
      for (const n of t)
        e = n(e, this);
      return e;
    };
  }
}
function K(s, t = S, e = !0) {
  return m(Symbol(), (n) => {
    w.set(n, { type: "cell", distinct: e, initial: s, init: t });
  });
}
function W(s = S, t = !1) {
  return m(Symbol(), (e) => {
    w.set(e, { type: "signal", distinct: t, init: s });
  });
}
function $(s = S) {
  return m(Symbol(), (t) => {
    w.set(t, { type: "signal", distinct: !1, init: s });
  });
}
const I = b.createContext(null);
function q({
  children: s,
  initWith: t,
  updateWith: e = {}
}) {
  const n = b.useMemo(() => new j(t), []);
  return b.useEffect(() => {
    n.pubIn(e);
  }, [e, n]), /* @__PURE__ */ E(I.Provider, { value: n, children: s });
}
function x() {
  const s = b.useContext(I);
  if (s === null)
    throw new Error("useRealm must be used within a RealmContextProvider");
  return s;
}
function O(s) {
  const t = x();
  t.register(s);
  const e = b.useCallback((n) => t.sub(s, n), [t, s]);
  return b.useSyncExternalStore(
    e,
    () => t.getValue(s),
    () => t.getValue(s)
  );
}
function D(...s) {
  const t = x();
  return O(t.combineCells.apply(t, s));
}
function v(s) {
  const t = x();
  return t.register(s), b.useCallback(
    (e) => {
      t.pub(s, e);
    },
    [t, s]
  );
}
function F(s) {
  return [O(s), v(s)];
}
function L(s) {
  return (t, e) => {
    const n = e.signalInstance();
    return e.connect({
      map: (i) => (r) => {
        i(s(r));
      },
      sink: n,
      sources: [t]
    }), n;
  };
}
function z(...s) {
  return (t, e) => {
    const n = e.signalInstance();
    return e.connect({
      map: (i) => (...r) => {
        i(r);
      },
      pulls: s,
      sink: n,
      sources: [t]
    }), n;
  };
}
function B(s) {
  return (t, e) => {
    const n = e.signalInstance();
    return e.connect({
      map: (i) => () => {
        i(s);
      },
      sink: n,
      sources: [t]
    }), n;
  };
}
function G(s) {
  return (t, e) => {
    const n = e.signalInstance();
    return e.connect({
      map: (i) => (r) => {
        s(r) && i(r);
      },
      sink: n,
      sources: [t]
    }), n;
  };
}
function H() {
  return (s, t) => {
    const e = t.signalInstance();
    let n = !1;
    return t.connect({
      map: (i) => (r) => {
        n || (n = !0, i(r));
      },
      sink: e,
      sources: [s]
    }), e;
  };
}
function J(s, t) {
  return (e, n) => {
    const i = n.signalInstance();
    return n.connect({
      map: (r) => (o) => {
        r(t = s(t, o));
      },
      sink: i,
      sources: [e]
    }), i;
  };
}
function Q(s) {
  return (t, e) => {
    const n = e.signalInstance();
    let i, r = null;
    return e.sub(t, (o) => {
      i = o, r === null && (r = setTimeout(() => {
        r = null, e.pub(n, i);
      }, s));
    }), n;
  };
}
function U(s) {
  return (t, e) => {
    const n = e.signalInstance();
    let i, r = null;
    return e.sub(t, (o) => {
      i = o, r !== null && clearTimeout(r), r = setTimeout(() => {
        e.pub(n, i);
      }, s);
    }), n;
  };
}
function X() {
  return (s, t) => {
    const e = t.signalInstance();
    return t.sub(s, (n) => {
      queueMicrotask(() => {
        t.pub(e, n);
      });
    }), e;
  };
}
function Y(s) {
  return (t, e) => {
    const n = e.signalInstance(), i = Symbol();
    let r = i;
    return e.connect({
      map: (o) => (l) => {
        r !== i && (o([r, l]), r = i);
      },
      sink: n,
      sources: [s]
    }), e.sub(t, (o) => r = o), n;
  };
}
function Z(s, t, e) {
  return (n, i) => {
    const r = i.signalInstance();
    return i.sub(n, (o) => {
      o !== null && typeof o == "object" && "then" in o ? (i.pub(r, s()), o.then((l) => {
        i.pub(r, t(l));
      }).catch((l) => {
        i.pub(r, e(l));
      })) : i.pub(r, t(o));
    }), r;
  };
}
export {
  $ as Action,
  K as Cell,
  j as Realm,
  I as RealmContext,
  q as RealmProvider,
  W as Signal,
  U as debounceTime,
  C as defaultComparator,
  X as delayWithMicrotask,
  G as filter,
  Z as handlePromise,
  L as map,
  B as mapTo,
  Y as onNext,
  H as once,
  J as scan,
  Q as throttleTime,
  F as useCell,
  O as useCellValue,
  D as useCellValues,
  v as usePublisher,
  x as useRealm,
  z as withLatestFrom
};
